/* eslint-disable */
export const questions = [
  {
    "model": "participants.question",
    "pk": 1,
    "fields": {
      "slug": "diet-approach",
      "question_text": "How are you approaching your diet?",
      "order": 1,
      "section": "success_questions",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 2,
    "fields": {
      "slug": "weight-loss-programs",
      "question_text": "Which of the following weight loss programs do you plan to use? (select your primary plan)",
      "order": 2,
      "section": "success_questions",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 3,
    "fields": {
      "slug": "amount-of-support",
      "question_text": "To help us understand the amount of support you have. What is your living situation like?",
      "order": 3,
      "section": "success_questions",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 4,
    "fields": {
      "slug": "competitions",
      "question_text": "Do you enjoy competitions? (i.e., sports, games, etc.)",
      "order": 4,
      "section": "success_questions",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 5,
    "fields": {
      "slug": "current-state-of-mind",
      "question_text": "To help us better understand your current state of mind. How motivated are you to reach your target weight?",
      "order": 5,
      "section": "success_questions",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 6,
    "fields": {
      "slug": "diet-plan",
      "question_text": "Have you picked a diet plan you want to commit to yet?",
      "order": 6,
      "section": "success_questions",
      "multiple": false,
      "active": false,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 7,
    "fields": {
      "slug": "paid-program-or-diet-plan",
      "question_text": "Are you doing a paid program or following a diet plan? (i.e., keto, low, fat, etc.)",
      "order": 7,
      "section": "success_questions",
      "multiple": false,
      "active": false,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 8,
    "fields": {
      "slug": "weight-loss-programs-or-diet-plan-use",
      "question_text": "Great! Which of the following weight loss programs or diets do you plan to use?",
      "order": 8,
      "section": "success_questions",
      "multiple": true,
      "active": false,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 9,
    "fields": {
      "slug": "exercise-plan",
      "question_text": "Have you picked an exercise plan you want to commit to yet?",
      "order": 9,
      "section": "success_questions",
      "multiple": false,
      "active": false,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 10,
    "fields": {
      "slug": "exercise-programs-plan-use",
      "question_text": "Great! Which of the following exercise programs do you plan to use? (click all that apply)",
      "order": 10,
      "section": "success_questions",
      "multiple": true,
      "active": false,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 11,
    "fields": {
      "slug": "idealWeight",
      "question_text": "Is {{currentWeight}} lbs your ideal weight?",
      "order": 2,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 12,
    "fields": {
      "slug": "motivationSelection",
      "question_text": "Our program is all about motivation. Why do you want to lose weight? (click all that apply)",
      "order": 4,
      "section": "funnel",
      "multiple": true,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 13,
    "fields": {
      "slug": "dietSelection2",
      "question_text": "Do you sometimes have trouble sticking with your diet?",
      "order": 6,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": true
    }
  },
  {
    "model": "participants.question",
    "pk": 14,
    "fields": {
      "slug": "triedProgramSelection",
      "question_text": "Which have you tried? (select all that apply)",
      "order": 3,
      "section": "funnel",
      "multiple": true,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 15,
    "fields": {
      "slug": "foodControl",
      "question_text": "Are you in control of your food intake?",
      "order": 5,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": true
    }
  },
  {
    "model": "participants.question",
    "pk": 16,
    "fields": {
      "slug": "wantedWeightDuration",
      "question_text": "How long have you weighed more than you wanted to?",
      "order": 1,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 19,
    "fields": {
      "slug": "age",
      "question_text": "What is your age?",
      "order": 1,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": true
    }
  },
  {
    "model": "participants.question",
    "pk": 20,
    "fields": {
      "slug": "attract",
      "question_text": "Which is more true for you?",
      "order": 2,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": true
    }
  },
  {
    "model": "participants.question",
    "pk": 21,
    "fields": {
      "slug": "triedProgramSelection2",
      "question_text": "Which diets have you tried in the past? (select all that apply)",
      "order": 3,
      "section": "funnel",
      "multiple": true,
      "active": false,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 22,
    "fields": {
      "slug": "weightHistory",
      "question_text": "How long have you weighted more than you've wanted to?",
      "order": 4,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": true
    }
  },
  {
    "model": "participants.question",
    "pk": 23,
    "fields": {
      "slug": "journey",
      "question_text": "When did you start your current weight loss journey?",
      "order": 5,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 24,
    "fields": {
      "slug": "pastChallenges",
      "question_text": "Have you ever participated in a weight loss competition other than HealthyWage in the past?",
      "order": 7,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 25,
    "fields": {
      "slug": "glp1",
      "question_text": "Are you taking a GLP-1 (Ozempic, Wegovy, etc.)? (Yes, it is allowed.)",
      "order": 8,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": true
    }
  },
  {
    "model": "participants.question",
    "pk": 26,
    "fields": {
      "slug": "physicalActivity",
      "question_text": "Do you enjoy getting your exercise?",
      "order": 9,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": true
    }
  },
  {
    "model": "participants.question",
    "pk": 27,
    "fields": {
      "slug": "sleep",
      "question_text": "How's your sleep?",
      "order": 10,
      "section": "funnel",
      "multiple": false,
      "active": true,
      "nonRandomizable": false
    }
  },
  {
    "model": "participants.question",
    "pk": 28,
    "fields": {
      "slug": "triedProgramSelection3",
      "question_text": "Which diets have you tried in the past? (select all that apply)",
      "order": 3,
      "section": "funnel",
      "multiple": true,
      "active": true,
      "nonRandomizable": false
    }
  },
]
